// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__EBt9p","signatureBlock":"Footer_signatureBlock__Ec-34","signature":"Footer_signature__k874M"};